import { render } from "./Pagination.vue?vue&type=template&id=26ba2965&scoped=true&ts=true"
import script from "./Pagination.vue?vue&type=script&lang=ts"
export * from "./Pagination.vue?vue&type=script&lang=ts"

import "../assets/scss/pagination.scss?vue&type=style&index=0&id=26ba2965&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26ba2965"]])

export default __exports__